import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CurrencyPipe, DialogBase, EmailTemplateInfo, ObjectTypeInfo, T4RentalService } from 't4core';
import { RentalObjectInfo } from '../../../../../projects/t4core/src/public-api';

@Component({
  selector: 't4-RequestPaymentDialog',
  templateUrl: 'RequestPaymentDialog.html',
})
export class RequestPaymentDialog extends DialogBase implements OnInit {
  public rentalId: number = 0;
  public email: string = "";
  public amount: number = 0;
  public description: string = "";
  public firstname: string = "";


  //Used for the filter. (Enum Value)

  private _selectedSmsType: string;


  public templates: EmailTemplateInfo[];
  public smsTypeOptions: SmsTypeOption[] = [];

  public contextName: string = "";



  public phone: string;
  public website: string;

  //SMS Templats only for BackOffice.
  public backoffice: boolean = this.Settings.isInAny(['BackOffice'], true);

  //Used for the Mat-Select
  templateKeys = [];

  constructor(public dialogRef: MatDialogRef<RequestPaymentDialog>, @Inject(MAT_DIALOG_DATA) public data: any, private rentalService: T4RentalService, private cPipe: CurrencyPipe) {
    super("RequestPaymentDialog");

    this.rentalId = data.rentalId;
    this.email = data.email;
    this.amount = data.amount;
    this.firstname = data.firstname;
  }

  async ngOnInit() {
    //Get all our Templates we have access to in our current context.
    this.templates = await this.Api.get<EmailTemplateInfo[]>("Settings/GetContentTemplatesByKey", { type: 1, key: "T4.Core.SMS.PaymentRequest." });
    //Generated options for the mat select.
    for (const template of this.templates) {
      this.smsTypeOptions.push({
        displayName: this.getDisplayName(template.Key),
        fullKey: template.Key
      });
    }
  }

  getDisplayName(type: string): string {
    return type.split('.').pop() ?? type;
  }

  updateDescription(templateText: string): string {
    return templateText
      .replace('${this.firstname}', this.firstname)
      .replace('${this.rentalId}', this.rentalId.toString())
  }


  public async validate() {

    var filtertedDescription = this.description.replace(/\n/g, " ");

    var ret = await this.Api.post<number>("Rental/RequestPayment", null, { rentalId: this.rentalId, description: filtertedDescription });
    if (ret) {
      this.dialogRef.close(ret);
    }
  }

  public close() {
    this.dialogRef.close();
  }

  // When we change the type.
  public onSmsTypeChange(fullKey: string) {
    this._selectedSmsType = fullKey;
    this.updateSelectedTemplate();
  }

  public async updateSelectedTemplate() {
    const selectedTemplate = this.templates.find(t => t.Key === this._selectedSmsType).Content;
    this.description = this.updateDescription(selectedTemplate);
  }

}

type SmsTypeOption = {
  displayName: string;
  fullKey: string;
};


